module.exports = __webpack_public_path__ + "img/access-active.a264a353.png";